import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })

export class  SessionStorageService {
    /**
     * @method SessionSetItem
     * @input params storage name storage value
     * @output None
     * @description set the sesion storage
     */
     SessionSetItem(SessionKey: string, SessionValue: any): void {
         try {
           const GetSessionValue = JSON.stringify(SessionValue);
           sessionStorage.setItem(SessionKey, GetSessionValue);
         } catch ( error ) {
             console.error(error);
         }
     }

    /**
     * @method SessionSetItem
     * @input params storage name storage value
     * @output None
     * @description set the sesion storage
     */
        SessionGetItem(SessionKey: string, IsParsed = false): any {
            try {
                let GetSessionValue = sessionStorage.getItem(SessionKey);
                if ( IsParsed ) {
                    GetSessionValue = JSON.parse(GetSessionValue);
                }
                return GetSessionValue;
            } catch ( error ) {
                console.error(error);
            }
        }

          /**
     * @method localstorageSetItem
     * @input params storage name storage value
     * @output None
     * @description set the sesion storage
     */
        localstorageSetItem(SessionKey: string, SessionValue: any): void {
        try {
          const GetSessionValue = JSON.stringify(SessionValue);
          localStorage.setItem(SessionKey, GetSessionValue)
        } catch ( error ) {
            console.error(error);
        }
    }
    /**
     * @method localStorageGetItem
     * @input params storage name storage value
     * @output None
     * @description set the sesion storage
     */
     localStorageGetItem(SessionKey: string, IsParsed = false): any {
        try {
            let GetSessionValue = localStorage.getItem(SessionKey);
            if ( IsParsed ) {
                GetSessionValue = JSON.parse(GetSessionValue);
            }
            return GetSessionValue;
        } catch ( error ) {
            console.error(error);
        }
    }
}
